import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadCalculationService } from './load-calculation.service';
import { CalculationsService } from '../../../api/services/calculations.service';
import { ProgressSpinnerService } from '../../components/progress-spinner/progress-spinner.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'rc-load-calculation',
  templateUrl: './load-calculation.component.html',
})
export class LoadCalculationComponent implements OnInit {
  message = '';
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly service: LoadCalculationService,
    private readonly calculationsService: CalculationsService,
    private readonly progressSpinnerService: ProgressSpinnerService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.progressSpinnerService.openProgressSpinner();
    const calculationId = this.route.snapshot.paramMap.get('calculationId');
    try {
      if (calculationId) {
        const calculation = await lastValueFrom(
          this.calculationsService.calculationsControllerGetCalculation({ id: calculationId }),
        );
        await this.service.loadCalculation(calculation);
      } else {
        this.router.navigate(['404']);
      }
    } catch (error: any) {
      if (error.status === 404) {
        this.router.navigate(['404']);
      }
      console.log(error);
    }
    this.progressSpinnerService.closeProgressSpinner();
  }
}
